/**
 * 页面提交数据的操作逻辑
 */
export default {
    data () {
        return {
            submitCompNumber: 0, // 需要提交数据的容器组件有几个
            submitData: {}, // 要提交的数据
            submitParams: {} // 提交需要的相关参数
        }
    },
    created () {
        // 监听数据的提交事件
        this.$eventHub.$on(this.$events.SUBMIT_DATA, this.handleSubmitData)
        // 监听容器给过来的数据
        this.$eventHub.$on(this.$events.HERE_YOU_SUBMIT_DATA, this.handleHereYouSubmitData)
    },
    methods: {
        /**
         * 监听数据的提交事件
         * @params 提交的相关参数
         *  params 需要的字段 
         * {
         *  api: // 提交的API
            method: // 提交的方式
            route: // 提交过后跳转的页面
            mark: // 以page中那个字段的对象 取参数对象
         * }
         */
        handleSubmitData (params) {
            Object.assign(this.submitParams, params)
            // 获得需要提交数据的容器组件有几个
            this.submitCompNumber = 0
            this.currPage && this.currPage.children.forEach((el) => {
                if (el.isSubmit) {
                    this.submitCompNumber++
                }
            })            
            // 给容器组件说，把要提交的数据发过来
            this.$eventHub.$emit(this.$events.GIVE_ME_SUBMIT_DATA)
        },
        /**
         * 监听容器给过来的数据
         */
        handleHereYouSubmitData (data) {
            Object.assign(this.submitData, data)
            // 递减需要的数据数量
            this.submitCompNumber--
            // 所有要提交的数据都得到了的话，进行数据的提交
            if (this.submitCompNumber == 0) {
                this.doSubmit()
            }
        },
        /**
         * 进行数据的提交
         */
        doSubmit () {
            this.isSpinShow = true
            // 组装提交的url
            let url = this.submitParams.api 
            if (this.submitParams.mark && this.submitParams.mark.length > 0) {
                let path = this.$path.getPath(url, this.pageInfo[this.submitParams.mark], this.submitParams.method)
                if (typeof path == 'string') {
                    url = path
                } else if (typeof path == 'object'){ // POST上传参数
                    url = path.url
                    Object.assign(this.submitData, path.params)
                }
            }
            this.$api[this.submitParams.method](url, this.submitData).then((rs) => {
                this.$Message.success('保存成功')
                this.isSpinShow = false
                // 刷新当前页面
                if (this.submitParams.route == ':rf') {
                    location.reload()
                } else {
                    // 跳转路由
                    this.$router.push({path: this.$path.getPath(this.submitParams.route, rs)})
                }
                this.submitData = {}
            }).catch((err) => {
                this.isSpinShow = false
                console.error(err)
                this.$Message.error({content: err, duration: 5 })
            })
        }
    },
    destroyed () {
        // 销毁事件的监听
        this.$eventHub.$off(this.$events.SUBMIT_DATA, this.handleSubmitData)
        this.$eventHub.$off(this.$events.HERE_YOU_SUBMIT_DATA, this.handleHereYouSubmitData)
    }
}


// WEBPACK FOOTER //
// ./src/utils/pageSubmit.mixin.js